import { render, staticRenderFns } from "./DecksContainer.vue?vue&type=template&id=8af5a710"
import script from "./DecksContainer.vue?vue&type=script&lang=js"
export * from "./DecksContainer.vue?vue&type=script&lang=js"
import style0 from "./DecksContainer.vue?vue&type=style&index=0&id=8af5a710&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports